var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-format":"auto","data-full-width-responsive":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }